module.exports = __webpack_public_path__ + "static/media/b1_p11_boomer.a6c38ce1.mp3";